//* Config imports
import { API_URL, getAuthHeaders } from "@/config/api";

export function useGetClientProducts() {
  const getClientProducts = async (clientId: string) => {
    const response = await fetch(
      `${API_URL}/clients/get_client_products?client_id=${clientId}`,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.json();
  };

  return { getClientProducts };
}
